import { store } from '../store'

export default (to, from, next) => {
  if (to.name !== 'Signin' &&
      to.name !== 'Signup' &&
      to.name !== 'ResetPassword' &&
      to.name !== 'ResetPasswordByLink') {
    if (store.getters.isLoggedIn) {
      return next()
    } else {
      return next(`/signin?redirect=${to.path}`)
    }
  } else {
    if (store.getters.isLoggedIn) {
      return next('/products')
    } else {
      return next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js